import { createWorkshopRecordStore } from "@/lib/create-workshop-record-store";

/**
 * Facilitation notes register (Track A · REG-FACNOTES). A free-text running
 * note a facilitator jots during a session — "the room pushed back on X",
 * "park the budget question". Deliberately **statusless** (P2-US2): unlike
 * the other registers it has no lifecycle, it's just dated prose. Surfaced
 * as a Repository section and read-through into the Log's "Notes" tab.
 * Built on {@link createWorkshopRecordStore}.
 */

export type FacilitationNote = {
  id: string;
  workshopId: string;
  /** The note text. */
  body: string;
  createdAt: number;
  addedBy: string;
  /** Free-form tags (P0.1 seam). */
  tags?: string[];
};

export type FacilitationNotePatch = Partial<
  Pick<FacilitationNote, "body" | "tags">
>;

export const useFacilitationNotes = createWorkshopRecordStore<
  FacilitationNote,
  FacilitationNotePatch
>({
  idbKey: "xaes-facilitation-notes",
  recordType: "facilitation-notes",
  sanitiseItem: (n, fallbackWorkshopId) => {
    if (typeof n.id !== "string") return null;
    if (typeof n.body !== "string") return null;
    return {
      id: n.id,
      workshopId:
        typeof n.workshopId === "string" ? n.workshopId : fallbackWorkshopId,
      body: n.body,
      createdAt: typeof n.createdAt === "number" ? n.createdAt : Date.now(),
      addedBy: typeof n.addedBy === "string" ? n.addedBy : "",
      tags: Array.isArray(n.tags)
        ? n.tags.filter((t): t is string => typeof t === "string")
        : undefined,
    };
  },
});
